<template>
  <spinner :message="message" />
</template>

<script>
import spinner from '@/components/shared/Spinner.vue'

export default {
  name: 'Loading',
  components: { spinner },
  props: ['message'],
}
</script>

<style scoped>
</style>
